module.exports = __webpack_public_path__ + "kangping/img/female.7961c554.png";